/**
 * Base Form Module
 * Module chính chứa tất cả components, services của base form system
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Components
import { BaseFormComponent } from './components/base-form/base-form.component';
import { FormFieldComponent } from './components/form-field/form-field.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';

// Services
import { FormBuilderService } from './services/form-builder.service';
import { ValidationService } from './services/validation.service';
import { AsyncValidationService } from './services/async-validation.service';

@NgModule({
    declarations: [
        BaseFormComponent,
        FormFieldComponent,
        ErrorMessageComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        FlexLayoutModule,
        MatDatepickerModule,
        MatNativeDateModule
    ],
    exports: [
        BaseFormComponent,
        FormFieldComponent,
        ErrorMessageComponent
    ],
    providers: [
        FormBuilderService,
        ValidationService,
        AsyncValidationService
    ]
})
export class BaseFormModule { }
